module.exports = __webpack_public_path__ + "static/media/19_potolok_2.14_9.72.2d4522cb.png";